import { render, staticRenderFns } from "./partRequests.vue?vue&type=template&id=5360692f&scoped=true"
import script from "./partRequests.vue?vue&type=script&lang=js"
export * from "./partRequests.vue?vue&type=script&lang=js"
import style0 from "./partRequests.vue?vue&type=style&index=0&id=5360692f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5360692f",
  null
  
)

export default component.exports